const countries = {
  data: [
    { id: 4, alpha2Code: "AF", alpha3Code: "AFG", name: "Afghanistan" },
    { id: 8, alpha2Code: "AL", alpha3Code: "ALB", name: "Albania" },
    { id: 12, alpha2Code: "DZ", alpha3Code: "DZA", name: "Algeria" },
    { id: 20, alpha2Code: "AD", alpha3Code: "AND", name: "Andorra" },
    { id: 24, alpha2Code: "AO", alpha3Code: "AGO", name: "Angola" },
    {
      id: 28,
      alpha2Code: "AG",
      alpha3Code: "ATG",
      name: "Antigua and Barbuda"
    },
    { id: 32, alpha2Code: "AR", alpha3Code: "ARG", name: "Argentina" },
    { id: 51, alpha2Code: "AM", alpha3Code: "ARM", name: "Armenia" },
    { id: 36, alpha2Code: "AU", alpha3Code: "AUS", name: "Australia" },
    { id: 40, alpha2Code: "AT", alpha3Code: "AUT", name: "Austria" },
    { id: 31, alpha2Code: "AZ", alpha3Code: "AZE", name: "Azerbaijan" },
    { id: 44, alpha2Code: "BS", alpha3Code: "BHS", name: "Bahamas" },
    { id: 48, alpha2Code: "BH", alpha3Code: "BHR", name: "Bahrain" },
    { id: 50, alpha2Code: "BD", alpha3Code: "BGD", name: "Bangladesh" },
    { id: 52, alpha2Code: "BB", alpha3Code: "BRB", name: "Barbados" },
    { id: 112, alpha2Code: "BY", alpha3Code: "BLR", name: "Belarus" },
    { id: 56, alpha2Code: "BE", alpha3Code: "BEL", name: "Belgium" },
    { id: 84, alpha2Code: "BZ", alpha3Code: "BLZ", name: "Belize" },
    { id: 204, alpha2Code: "BJ", alpha3Code: "BEN", name: "Benin" },
    { id: 64, alpha2Code: "BT", alpha3Code: "BTN", name: "Bhutan" },
    {
      id: 68,
      alpha2Code: "BO",
      alpha3Code: "BOL",
      name: "Bolivia (Plurinational State of)"
    },
    {
      id: 70,
      alpha2Code: "BA",
      alpha3Code: "BIH",
      name: "Bosnia and Herzegovina"
    },
    { id: 72, alpha2Code: "BW", alpha3Code: "BWA", name: "Botswana" },
    { id: 76, alpha2Code: "BR", alpha3Code: "BRA", name: "Brazil" },
    { id: 96, alpha2Code: "BN", alpha3Code: "BRN", name: "Brunei Darussalam" },
    { id: 100, alpha2Code: "BG", alpha3Code: "BGR", name: "Bulgaria" },
    { id: 854, alpha2Code: "BF", alpha3Code: "BFA", name: "Burkina Faso" },
    { id: 108, alpha2Code: "BI", alpha3Code: "BDI", name: "Burundi" },
    { id: 132, alpha2Code: "CV", alpha3Code: "CPV", name: "Cabo Verde" },
    { id: 116, alpha2Code: "KH", alpha3Code: "KHM", name: "Cambodia" },
    { id: 120, alpha2Code: "CM", alpha3Code: "CMR", name: "Cameroon" },
    { id: 124, alpha2Code: "CA", alpha3Code: "CAN", name: "Canada" },
    {
      id: 140,
      alpha2Code: "CF",
      alpha3Code: "CAF",
      name: "Central African Republic"
    },
    { id: 148, alpha2Code: "TD", alpha3Code: "TCD", name: "Chad" },
    { id: 152, alpha2Code: "CL", alpha3Code: "CHL", name: "Chile" },
    { id: 156, alpha2Code: "CN", alpha3Code: "CHN", name: "China" },
    { id: 170, alpha2Code: "CO", alpha3Code: "COL", name: "Colombia" },
    { id: 174, alpha2Code: "KM", alpha3Code: "COM", name: "Comoros" },
    { id: 178, alpha2Code: "CG", alpha3Code: "COG", name: "Congo" },
    {
      id: 180,
      alpha2Code: "CD",
      alpha3Code: "COD",
      name: "Congo, Democratic Republic of the"
    },
    { id: 188, alpha2Code: "CR", alpha3Code: "CRI", name: "Costa Rica" },
    { id: 384, alpha2Code: "CI", alpha3Code: "CIV", name: "Côte d'Ivoire" },
    { id: 191, alpha2Code: "HR", alpha3Code: "HRV", name: "Croatia" },
    { id: 192, alpha2Code: "CU", alpha3Code: "CUB", name: "Cuba" },
    { id: 196, alpha2Code: "CY", alpha3Code: "CYP", name: "Cyprus" },
    { id: 203, alpha2Code: "CZ", alpha3Code: "CZE", name: "Czechia" },
    { id: 208, alpha2Code: "DK", alpha3Code: "DNK", name: "Denmark" },
    { id: 262, alpha2Code: "DJ", alpha3Code: "DJI", name: "Djibouti" },
    { id: 212, alpha2Code: "DM", alpha3Code: "DMA", name: "Dominica" },
    {
      id: 214,
      alpha2Code: "DO",
      alpha3Code: "DOM",
      name: "Dominican Republic"
    },
    { id: 218, alpha2Code: "EC", alpha3Code: "ECU", name: "Ecuador" },
    { id: 818, alpha2Code: "EG", alpha3Code: "EGY", name: "Egypt" },
    { id: 222, alpha2Code: "SV", alpha3Code: "SLV", name: "El Salvador" },
    { id: 226, alpha2Code: "GQ", alpha3Code: "GNQ", name: "Equatorial Guinea" },
    { id: 232, alpha2Code: "ER", alpha3Code: "ERI", name: "Eritrea" },
    { id: 233, alpha2Code: "EE", alpha3Code: "EST", name: "Estonia" },
    { id: 748, alpha2Code: "SZ", alpha3Code: "SWZ", name: "Eswatini" },
    { id: 231, alpha2Code: "ET", alpha3Code: "ETH", name: "Ethiopia" },
    { id: 242, alpha2Code: "FJ", alpha3Code: "FJI", name: "Fiji" },
    { id: 246, alpha2Code: "FI", alpha3Code: "FIN", name: "Finland" },
    { id: 250, alpha2Code: "FR", alpha3Code: "FRA", name: "France" },
    { id: 266, alpha2Code: "GA", alpha3Code: "GAB", name: "Gabon" },
    { id: 270, alpha2Code: "GM", alpha3Code: "GMB", name: "Gambia" },
    { id: 268, alpha2Code: "GE", alpha3Code: "GEO", name: "Georgia" },
    { id: 276, alpha2Code: "DE", alpha3Code: "DEU", name: "Germany" },
    { id: 288, alpha2Code: "GH", alpha3Code: "GHA", name: "Ghana" },
    { id: 300, alpha2Code: "GR", alpha3Code: "GRC", name: "Greece" },
    { id: 308, alpha2Code: "GD", alpha3Code: "GRD", name: "Grenada" },
    { id: 320, alpha2Code: "GT", alpha3Code: "GTM", name: "Guatemala" },
    { id: 324, alpha2Code: "GN", alpha3Code: "GIN", name: "Guinea" },
    { id: 624, alpha2Code: "GW", alpha3Code: "GNB", name: "Guinea-Bissau" },
    { id: 328, alpha2Code: "GY", alpha3Code: "GUY", name: "Guyana" },
    { id: 332, alpha2Code: "HT", alpha3Code: "HTI", name: "Haiti" },
    { id: 340, alpha2Code: "HN", alpha3Code: "HND", name: "Honduras" },
    { id: 348, alpha2Code: "HU", alpha3Code: "HUN", name: "Hungary" },
    { id: 352, alpha2Code: "IS", alpha3Code: "ISL", name: "Iceland" },
    { id: 356, alpha2Code: "IN", alpha3Code: "IND", name: "India" },
    { id: 360, alpha2Code: "ID", alpha3Code: "IDN", name: "Indonesia" },
    {
      id: 364,
      alpha2Code: "IR",
      alpha3Code: "IRN",
      name: "Iran (Islamic Republic of)"
    },
    { id: 368, alpha2Code: "IQ", alpha3Code: "IRQ", name: "Iraq" },
    { id: 372, alpha2Code: "IE", alpha3Code: "IRL", name: "Ireland" },
    { id: 376, alpha2Code: "IL", alpha3Code: "ISR", name: "Israel" },
    { id: 380, alpha2Code: "IT", alpha3Code: "ITA", name: "Italy" },
    { id: 388, alpha2Code: "JM", alpha3Code: "JAM", name: "Jamaica" },
    { id: 392, alpha2Code: "JP", alpha3Code: "JPN", name: "Japan" },
    { id: 400, alpha2Code: "JO", alpha3Code: "JOR", name: "Jordan" },
    { id: 398, alpha2Code: "KZ", alpha3Code: "KAZ", name: "Kazakhstan" },
    { id: 404, alpha2Code: "KE", alpha3Code: "KEN", name: "Kenya" },
    { id: 296, alpha2Code: "KI", alpha3Code: "KIR", name: "Kiribati" },
    {
      id: 408,
      alpha2Code: "KP",
      alpha3Code: "PRK",
      name: "Korea (Democratic People's Republic of)"
    },
    {
      id: 410,
      alpha2Code: "KR",
      alpha3Code: "KOR",
      name: "Republic of Korea"
    },
    { id: 414, alpha2Code: "KW", alpha3Code: "KWT", name: "Kuwait" },
    { id: 417, alpha2Code: "KG", alpha3Code: "KGZ", name: "Kyrgyzstan" },
    {
      id: 418,
      alpha2Code: "LA",
      alpha3Code: "LAO",
      name: "Lao People's Democratic Republic"
    },
    { id: 428, alpha2Code: "LV", alpha3Code: "LVA", name: "Latvia" },
    { id: 422, alpha2Code: "LB", alpha3Code: "LBN", name: "Lebanon" },
    { id: 426, alpha2Code: "LS", alpha3Code: "LSO", name: "Lesotho" },
    { id: 430, alpha2Code: "LR", alpha3Code: "LBR", name: "Liberia" },
    { id: 434, alpha2Code: "LY", alpha3Code: "LBY", name: "Libya" },
    { id: 438, alpha2Code: "LI", alpha3Code: "LIE", name: "Liechtenstein" },
    { id: 440, alpha2Code: "LT", alpha3Code: "LTU", name: "Lithuania" },
    { id: 442, alpha2Code: "LU", alpha3Code: "LUX", name: "Luxembourg" },
    { id: 450, alpha2Code: "MG", alpha3Code: "MDG", name: "Madagascar" },
    { id: 454, alpha2Code: "MW", alpha3Code: "MWI", name: "Malawi" },
    { id: 458, alpha2Code: "MY", alpha3Code: "MYS", name: "Malaysia" },
    { id: 462, alpha2Code: "MV", alpha3Code: "MDV", name: "Maldives" },
    { id: 466, alpha2Code: "ML", alpha3Code: "MLI", name: "Mali" },
    { id: 470, alpha2Code: "MT", alpha3Code: "MLT", name: "Malta" },
    { id: 584, alpha2Code: "MH", alpha3Code: "MHL", name: "Marshall Islands" },
    { id: 478, alpha2Code: "MR", alpha3Code: "MRT", name: "Mauritania" },
    { id: 480, alpha2Code: "MU", alpha3Code: "MUS", name: "Mauritius" },
    { id: 484, alpha2Code: "MX", alpha3Code: "MEX", name: "Mexico" },
    {
      id: 583,
      alpha2Code: "FM",
      alpha3Code: "FSM",
      name: "Micronesia (Federated States of)"
    },
    {
      id: 498,
      alpha2Code: "MD",
      alpha3Code: "MDA",
      name: "Moldova, Republic of"
    },
    { id: 492, alpha2Code: "MC", alpha3Code: "MCO", name: "Monaco" },
    { id: 496, alpha2Code: "MN", alpha3Code: "MNG", name: "Mongolia" },
    { id: 499, alpha2Code: "ME", alpha3Code: "MNE", name: "Montenegro" },
    { id: 504, alpha2Code: "MA", alpha3Code: "MAR", name: "Morocco" },
    { id: 508, alpha2Code: "MZ", alpha3Code: "MOZ", name: "Mozambique" },
    { id: 104, alpha2Code: "MM", alpha3Code: "MMR", name: "Myanmar" },
    { id: 516, alpha2Code: "NA", alpha3Code: "NAM", name: "Namibia" },
    { id: 520, alpha2Code: "NR", alpha3Code: "NRU", name: "Nauru" },
    { id: 524, alpha2Code: "NP", alpha3Code: "NPL", name: "Nepal" },
    { id: 528, alpha2Code: "NL", alpha3Code: "NLD", name: "Netherlands" },
    { id: 554, alpha2Code: "NZ", alpha3Code: "NZL", name: "New Zealand" },
    { id: 558, alpha2Code: "NI", alpha3Code: "NIC", name: "Nicaragua" },
    { id: 562, alpha2Code: "NE", alpha3Code: "NER", name: "Niger" },
    { id: 566, alpha2Code: "NG", alpha3Code: "NGA", name: "Nigeria" },
    { id: 807, alpha2Code: "MK", alpha3Code: "MKD", name: "North Macedonia" },
    { id: 578, alpha2Code: "NO", alpha3Code: "NOR", name: "Norway" },
    { id: 512, alpha2Code: "OM", alpha3Code: "OMN", name: "Oman" },
    { id: 586, alpha2Code: "PK", alpha3Code: "PAK", name: "Pakistan" },
    { id: 585, alpha2Code: "PW", alpha3Code: "PLW", name: "Palau" },
    { id: 591, alpha2Code: "PA", alpha3Code: "PAN", name: "Panama" },
    { id: 598, alpha2Code: "PG", alpha3Code: "PNG", name: "Papua New Guinea" },
    { id: 600, alpha2Code: "PY", alpha3Code: "PRY", name: "Paraguay" },
    { id: 604, alpha2Code: "PE", alpha3Code: "PER", name: "Peru" },
    { id: 608, alpha2Code: "PH", alpha3Code: "PHL", name: "Philippines" },
    { id: 616, alpha2Code: "PL", alpha3Code: "POL", name: "Poland" },
    { id: 620, alpha2Code: "PT", alpha3Code: "PRT", name: "Portugal" },
    { id: 634, alpha2Code: "QA", alpha3Code: "QAT", name: "Qatar" },
    { id: 642, alpha2Code: "RO", alpha3Code: "ROU", name: "Romania" },
    {
      id: 643,
      alpha2Code: "RU",
      alpha3Code: "RUS",
      name: "Russian Federation"
    },
    { id: 646, alpha2Code: "RW", alpha3Code: "RWA", name: "Rwanda" },
    {
      id: 659,
      alpha2Code: "KN",
      alpha3Code: "KNA",
      name: "Saint Kitts and Nevis"
    },
    { id: 662, alpha2Code: "LC", alpha3Code: "LCA", name: "Saint Lucia" },
    {
      id: 670,
      alpha2Code: "VC",
      alpha3Code: "VCT",
      name: "Saint Vincent and the Grenadines"
    },
    { id: 882, alpha2Code: "WS", alpha3Code: "WSM", name: "Samoa" },
    { id: 674, alpha2Code: "SM", alpha3Code: "SMR", name: "San Marino" },
    {
      id: 678,
      alpha2Code: "ST",
      alpha3Code: "STP",
      name: "Sao Tome and Principe"
    },
    { id: 682, alpha2Code: "SA", alpha3Code: "SAU", name: "Saudi Arabia" },
    { id: 686, alpha2Code: "SN", alpha3Code: "SEN", name: "Senegal" },
    { id: 688, alpha2Code: "RS", alpha3Code: "SRB", name: "Serbia" },
    { id: 690, alpha2Code: "SC", alpha3Code: "SYC", name: "Seychelles" },
    { id: 694, alpha2Code: "SL", alpha3Code: "SLE", name: "Sierra Leone" },
    { id: 702, alpha2Code: "SG", alpha3Code: "SGP", name: "Singapore" },
    { id: 703, alpha2Code: "SK", alpha3Code: "SVK", name: "Slovakia" },
    { id: 705, alpha2Code: "SI", alpha3Code: "SVN", name: "Slovenia" },
    { id: 90, alpha2Code: "SB", alpha3Code: "SLB", name: "Solomon Islands" },
    { id: 706, alpha2Code: "SO", alpha3Code: "SOM", name: "Somalia" },
    { id: 710, alpha2Code: "ZA", alpha3Code: "ZAF", name: "South Africa" },
    { id: 728, alpha2Code: "SS", alpha3Code: "SSD", name: "South Sudan" },
    { id: 724, alpha2Code: "ES", alpha3Code: "ESP", name: "Spain" },
    { id: 144, alpha2Code: "LK", alpha3Code: "LKA", name: "Sri Lanka" },
    { id: 729, alpha2Code: "SD", alpha3Code: "SDN", name: "Sudan" },
    { id: 740, alpha2Code: "SR", alpha3Code: "SUR", name: "Suriname" },
    { id: 752, alpha2Code: "SE", alpha3Code: "SWE", name: "Sweden" },
    { id: 756, alpha2Code: "CH", alpha3Code: "CHE", name: "Switzerland" },
    {
      id: 760,
      alpha2Code: "SY",
      alpha3Code: "SYR",
      name: "Syrian Arab Republic"
    },
    { id: 762, alpha2Code: "TJ", alpha3Code: "TJK", name: "Tajikistan" },
    {
      id: 834,
      alpha2Code: "TZ",
      alpha3Code: "TZA",
      name: "Tanzania, United Republic of"
    },
    { id: 764, alpha2Code: "TH", alpha3Code: "THA", name: "Thailand" },
    { id: 626, alpha2Code: "TL", alpha3Code: "TLS", name: "Timor-Leste" },
    { id: 768, alpha2Code: "TG", alpha3Code: "TGO", name: "Togo" },
    { id: 776, alpha2Code: "TO", alpha3Code: "TON", name: "Tonga" },
    {
      id: 780,
      alpha2Code: "TT",
      alpha3Code: "TTO",
      name: "Trinidad and Tobago"
    },
    { id: 788, alpha2Code: "TN", alpha3Code: "TUN", name: "Tunisia" },
    { id: 792, alpha2Code: "TR", alpha3Code: "TUR", name: "Turkey" },
    { id: 795, alpha2Code: "TM", alpha3Code: "TKM", name: "Turkmenistan" },
    { id: 798, alpha2Code: "TV", alpha3Code: "TUV", name: "Tuvalu" },
    { id: 800, alpha2Code: "UG", alpha3Code: "UGA", name: "Uganda" },
    { id: 804, alpha2Code: "UA", alpha3Code: "UKR", name: "Ukraine" },
    {
      id: 784,
      alpha2Code: "AE",
      alpha3Code: "ARE",
      name: "United Arab Emirates"
    },
    {
      id: 826,
      alpha2Code: "GB",
      alpha3Code: "GBR",
      name: "United Kingdom of Great Britain and Northern Ireland"
    },
    {
      id: 840,
      alpha2Code: "US",
      alpha3Code: "USA",
      name: "United States of America"
    },
    { id: 858, alpha2Code: "UY", alpha3Code: "URY", name: "Uruguay" },
    { id: 860, alpha2Code: "UZ", alpha3Code: "UZB", name: "Uzbekistan" },
    { id: 548, alpha2Code: "VU", alpha3Code: "VUT", name: "Vanuatu" },
    {
      id: 862,
      alpha2Code: "VE",
      alpha3Code: "VEN",
      name: "Venezuela (Bolivarian Republic of)"
    },
    { id: 704, alpha2Code: "VN", alpha3Code: "VNM", name: "Viet Nam" },
    { id: 887, alpha2Code: "YE", alpha3Code: "YEM", name: "Yemen" },
    { id: 894, alpha2Code: "ZM", alpha3Code: "ZMB", name: "Zambia" },
    { id: 716, alpha2Code: "ZW", alpha3Code: "ZWE", name: "Zimbabwe" },
    { id: 158, alpha2Code: "TW", alpha3Code: "TWN", name: "Taiwan" }
  ]
};

export class NationService {
  getListPublic() {
    return countries;
  }
  getNation(country_alpha_two_code) {
    const index = countries.data.findIndex(country => {
      return country.alpha2Code.toString() === country_alpha_two_code;
    });
    // console.log(index)

    return index > -1
      ? { data: countries.data[index] }
      : {
          data: { id: "", name: "", alpha2Code: "", alpha3Code: "" }
        };
  }
}
